import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import SignupForm from 'components/login/signup';
import LoginForm from 'components/login/login';
import ForgotPasswordForm from 'components/login/forgot';
import { signup, updateUser, login } from 'components/login/actions';
import { trackNow } from 'shared/models/analytic';

const Icon = () => <span className="svg-icon svg-icon--account" />;

let Collapsed = class Collapsed extends React.Component {
  renderTitle() {
    return (
      <div>
        <h2 className="checkout-section__title">Customer Info</h2>
      </div>
    );
  }

  renderSummary() {
    return (
      <div className="checkout-summary">
        <div>
          {this.props.user.firstname} {this.props.user.lastname}
        </div>
        <div>{this.props.user.email}</div>
        <div>{this.props.user.mobile}</div>
      </div>
    );
  }

  render() {
    return _.isEmpty(this.props.user.mobile)
      ? this.renderTitle()
      : this.renderSummary();
  }
};

Collapsed = connect(
  state => ({
    user: state.login.user || {}
  }),
  {}
)(Collapsed);

let Expanded = class Expanded extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: props.user,
      show: 'signup'
    };
    this.signup = this.props.signup.bind(this);
    this.updateUser = this.props.updateUser.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user.objectId !== this.props.user.objectId) {
      this.setState({ user: nextProps.user });
    }
  }

  showLogin() {
    this.setState({ show: 'login' });
    trackNow('Checkout Sign In Clicked');
  }

  showSignup() {
    this.setState({ show: 'signup' });
    trackNow('Checkout Create Account Clicked');
  }

  showForgotPassword() {
    this.setState({ show: 'forgot' });
    trackNow('Checkout Forgot Password Clicked');
  }

  render() {
    const customerSubmit = _.isEmpty(this.state.user)
      ? this.signup
      : this.updateUser;

    return (
      <div className="checkout-form-container">
        <div className="checkout-section__link right">
          {this.state.show === 'signup' &&
            _.isEmpty(this.state.user) && (
              <a className="link-text" onClick={() => this.showLogin()}>
                Sign In
              </a>
            )}
          {this.state.show === 'login' && (
            <a className="link-text" onClick={() => this.showSignup()}>
              Create an Account
            </a>
          )}
          {this.state.show === 'forgot' && (
            <a className="link-text" onClick={() => this.showLogin()}>
              Sign In
            </a>
          )}
        </div>
        <h2 className="checkout-section__title checkout-section__title--expanded">
          Customer Info
        </h2>
        {this.state.show === 'signup' && (
          <SignupForm
            onSubmit={customerSubmit}
            onSuccess={() => this.props.collapse()}
            checkout={true}
          />
        )}
        {this.state.show === 'login' && (
          <LoginForm
            email={this.props.user.email}
            showForgotPassword={() => this.showForgotPassword()}
            onSubmit={({ email, password }) =>
              this.props.login({ username: email, password })}
            onSuccess={() => {
              this.setState({ show: 'signup' });
              this.props.collapse();
            }}
          />
        )}
        {this.state.show === 'forgot' && (
          <ForgotPasswordForm email={this.props.user.email} />
        )}
      </div>
    );
  }
};

Expanded = connect(
  state => ({
    user: state.login.user || {}
  }),
  {
    signup,
    updateUser,
    login
  }
)(Expanded);

export default {
  Icon,
  Collapsed,
  Expanded
};



// WEBPACK FOOTER //
// ./shared/components/checkoutPage/customerInfo.js